<template>
    <div class="navigate-groups navigate-column" v-if="plugins.groups && plugins.groups === 'installed'">
        <div class="navigate">
            <div class="navigate-top">
                <div class="navigate-inner secondary-c">
                    <i class="far fa-users"></i>
                    <h2 v-if="Object.keys(translations).length > 0">{{ translations['groups.plural'] }}</h2>
                </div>
            </div>
            <div class="navigate-content-inner">
                <template v-if="data_loaded">
                    <template v-if="groups.length > 0">
                        <nav-group v-for="group in groups" :key="group.id" :group="group"></nav-group>
                        <a href="/groups">
                            <p v-if="Object.keys(translations).length > 0" class="navigate-more normal-text secondary-c hover-opacity">{{ translations['general.more'] }} {{ translations['groups.plural'].toLowerCase() }}</p>
                        </a>
                    </template>
                    <template v-else>
                        <div class="tw--mt-3">
                            <p class="light-text tw-mb-3">{{ translations['groups.not_joined_yet'] }}</p>
                            <a href="/groups">
                                <p class="navigate-more normal-text secondary-c hover-opacity" style="margin-top: 0;">{{ translations['groups.discover'] }}</p>
                            </a>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="tw-inline-flex">
                        <i class="far fa-spinner fa-spin light-text"></i>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global';
    import Channel from '../../lib/models/Channel';

    import NavGroup from "./NavGroup.vue";

    export default {
        name: 'NavBoards',

        mixins: [Global],

        components: {
            'nav-group': NavGroup
        },

        data() {
            return {
                data_loaded: false,
            };
        },

        computed: {
            groups() {
                return Channel.query().where('subgroup_id', null).where('template', 'default').where('source', 'user').orderBy('index').get();
            },
        },

        methods: {
            fetchMyGroups() {
                Channel.api().fetchSubscribedGroups(true).then(() => {
                    this.data_loaded = true;

                    this.$nextTick(() => Notifier.updateHTML());
                });
            },
        },

        updated() {
            if(typeof stickySidebar !== 'undefined') {
                stickySidebar.init();
            }
        },

        created() {
            this.fetchMyGroups();
        },
    };
</script>